export default __webpack_public_path__ + "static/media/Ballroll_00190.815ca424.png";